import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import { createAccessRepository } from "./accessRepository.js";
import { createAuthRepository } from "../auth/authRepository.js";
import { createAdminOperationsRepository } from "./adminOperationsRepository.js";
import { createAlertRepository } from "./alertRepository.js";
import { createAuditRepository } from "./auditRepository.js";
import { createBackendEndpointRepository } from "./backendEndpointRepository.js";
import { createCapaRepository } from "./capaRepository.js";
import { createCalendarRepository } from "./calendarRepository.js";
import { createComplaintRepository } from "./complaintRepository.js";
import { createConfigurationGovernanceRepository } from "./configurationGovernanceRepository.js";
import { createDashboardRepository } from "./dashboardRepository.js";
import { createEscalationRepository } from "./escalationRepository.js";
import { createEvidenceRepository } from "./evidenceRepository.js";
import { createLegacyReportRepository } from "./legacyReportRepository.js";
import { createMasterDataRepository } from "./masterDataRepository.js";
import { createMasterDependencyRepository } from "./masterDependencyRepository.js";
import { createMessageRepository } from "./messageRepository.js";
import { createNotificationRepository } from "./notificationRepository.js";
import { createOperationalReadinessRepository } from "./operationalReadinessRepository.js";
import { createRcaRepository } from "./rcaRepository.js";
import { createReferenceRepository } from "./referenceRepository.js";
import { createReportRepository } from "./reportRepository.js";
import { createReportExportRepository } from "./reportExportRepository.js";
import { createSecurityLogRepository } from "./securityLogRepository.js";
import { createSlaRepository } from "./slaRepository.js";
import { createSystemOperationsRepository } from "./systemOperationsRepository.js";
import { createTaskRepository } from "./taskRepository.js";
import { createTypedReportRepository } from "./typedReportRepository.js";
import { createVerificationRepository } from "./verificationRepository.js";
import { createWorkflowRepository } from "./workflowRepository.js";

export function createCmtsRepositorySuite(client: CmtsHttpClient) {
  return {
    access: createAccessRepository(client),
    auth: createAuthRepository(client),
    alerts: createAlertRepository(client),
    adminOperations: createAdminOperationsRepository(client),
    audit: createAuditRepository(client),
    backendEndpoints: createBackendEndpointRepository(client),
    calendar: createCalendarRepository(client),
    capa: createCapaRepository(client),
    complaints: createComplaintRepository(client),
    configurationGovernance: createConfigurationGovernanceRepository(client),
    dashboards: createDashboardRepository(client),
    escalation: createEscalationRepository(client),
    evidence: createEvidenceRepository(client),
    legacyReports: createLegacyReportRepository(client),
    masterData: createMasterDataRepository(client),
    masterDependencies: createMasterDependencyRepository(client),
    messages: createMessageRepository(client),
    notifications: createNotificationRepository(client),
    operationalReadiness: createOperationalReadinessRepository(client),
    rca: createRcaRepository(client),
    reference: createReferenceRepository(client),
    reports: createReportRepository(client),
    reportExports: createReportExportRepository(client),
    securityLogs: createSecurityLogRepository(client),
    sla: createSlaRepository(client),
    systemOperations: createSystemOperationsRepository(client),
    tasks: createTaskRepository(client),
    typedReports: createTypedReportRepository(client),
    verification: createVerificationRepository(client),
    workflow: createWorkflowRepository(client),
  };
}
export type CmtsRepositorySuite = ReturnType<typeof createCmtsRepositorySuite>;
